import React from 'react';
import image from '../../../../../assets/images/workshop-approach.png';

const WorkshopImage = (props) => (
    <div>
        <img style = {{height: props.height, width: props.width}} src={image} alt="workshop image"/>
    </div>
);
export default WorkshopImage;